<template>
    <path style="fill:#281F1F;" d="M69,38L69,38c-1.6-0.2-3.2-0.2-5.3-0.2c-1.4,0-2.9,0-4.2,0.1c-1,0-1.9,0.1-2.9,0.1c-0.2,0-0.6,0-1.1,0.1
		c-0.6,0-1.4,0.1-1.7,0.1c-0.4,0-1.1-0.1-1.7-0.1c-0.5,0-0.9-0.1-1.1-0.1c-0.9,0-1.9,0-2.9-0.1c-1.4,0-2.8-0.1-4.2-0.1
		c-2,0-3.7,0.1-5.2,0.2h-0.1c-3.9,0.4-5.7,1.1-5.8,2.1c0,0.6,0.2,0.7,0.5,0.7c0.1,0,0.3,0,0.4,0.1c0.7,0.5,1,0.8,1.2,1.6
		c0.7,2.4,1.5,4.3,3.2,6c1.4,1.5,3.6,2.1,5.3,2.1c0.1,0,0.3,0,0.4,0c1.8,0,4.3-0.4,5.3-1.4c1.2-1.1,2.1-3.6,2.8-5.8
		c0.6-1.7,1.2-3.6,1.7-3.6c0,0,0,0,0.1,0h0.1h0.1c0,0,0,0,0.1,0c0.5,0,1.2,1.9,1.7,3.6c0.7,2.2,1.6,4.7,2.8,5.8
		c1,0.9,3.5,1.4,5.3,1.4c0.1,0,0.3,0,0.4,0c1.7-0.1,3.9-0.7,5.3-2.1c1.6-1.7,2.4-3.7,3.2-6c0.2-0.8,0.5-1.1,1.2-1.6
		c0.1-0.1,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.2,0.5-0.7C74.7,39,72.9,38.4,69,38z M67.2,48.6c-1,0.6-2.4,0.9-3.8,0.9
		c-2.2,0-3.9-0.7-4.7-2s-2.6-6.8-2.2-7.5c0.2-0.4,1.2-1.2,5.5-1.2c0.9,0,1.7,0,2.1,0.1h0.2c2.3,0.1,4.1,0.3,5.7,0.8
		c0.3,0.1,0.6,0.5,0.6,1C70.9,43,68.9,47.6,67.2,48.6z M36.9,40.7c0.1-0.6,0.3-0.9,0.6-1c1.6-0.5,3.4-0.8,5.7-0.8h0.2
		c0.4,0,1.2-0.1,2.1-0.1c4.3,0,5.3,0.7,5.5,1.2c0.4,0.7-1.4,6.2-2.2,7.5c-0.7,1.2-2.5,2-4.7,2c-1.4,0-2.8-0.3-3.8-0.9
		C38.7,47.6,36.6,43,36.9,40.7z"/>
</template>

<script>
    export default {
        name: 'Eye14',
    }
</script>
